import { ChartOptions, ChartData } from "chart.js";
import { FunctionComponent, useEffect, useState } from "react";
import { getAttacksData } from "../api/Api";
import { TimeMeta, DatePoint, parseDatePoints, TimestampDataPoint } from "../api/types";
import { Line } from "react-chartjs-2";
import { CLOUDFLARE_ORANGE } from "../constants";
import "chartjs-adapter-date-fns";

export interface Props {}

export const AttacksGraph: FunctionComponent<Props> = () => {
  const [loading, setLoading] = useState(true);
  const [attacksData, setAttacksData] = useState<TimestampDataPoint[]>();
  const [metaData, setMetaData] = useState<TimeMeta>();

  useEffect(() => {
    setLoading(true);

    getAttacksData()
      .then((res) => {
        setAttacksData(res.data);
        setMetaData(res.meta);
        setLoading(false);
      })
      .catch((e) => {
        setLoading(false);
        alert(e);
      });
  }, []);

  if (loading) {
    return (
      <div className="loading-container">
        <p>Loading...</p>
      </div>
    );
  } else if (!attacksData || !metaData) {
    return (
      <div className="loading-container">
        <p>No Data</p>
      </div>
    );
  }

  const options: ChartOptions<"line"> = {
    plugins: {
      title: {
        display: true,
        text: "Cloudflare Layer 3 Attacks Over Time",
        font: {
          size: 30,
        },
      },
    },
    scales: {
      x: {
        type: "time",
        time: {
          unit: "day",
        },
        title: {
          display: true,
          text: "Time",
          font: {
            size: 16,
          },
        },
      },
      y: {
        type: "linear",
        beginAtZero: true,
        min: 0,
        max: 1.0,
        title: {
          display: true,
          text: "Amount",
          font: {
            size: 16,
          },
        },
      },
    },
  };

  const data: ChartData<"line", DatePoint[]> = {
    datasets: [
      {
        label: "Attacks",
        data: parseDatePoints(attacksData),
        borderColor: CLOUDFLARE_ORANGE,
      },
    ],
  };

  return (
    <div>
      <Line options={options} data={data} />
      <div className="last-updated">Last updated at {new Date(metaData.lastUpdated).toLocaleString()}</div>
    </div>
  );
};
